module.exports = __webpack_public_path__ + "assets/img/news-3.86862d59.jpg";